/* ShimChingMD — Home Ritual (Oct 2026) */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var WL = [
    { k: 'blue', nm: '415nm', name: 'Blue', c: '#6C8CE6' },
    { k: 'yellow', nm: '590nm', name: 'Yellow', c: '#E2B94F' },
    { k: 'red', nm: '660nm', name: 'Red', c: '#DD5036' },
    { k: 'nir', nm: '850nm', name: 'Near-infrared', c: '#9B2C22' }
  ];

  function inView(el, cb, opts) {
    if (!('IntersectionObserver' in window)) { cb(true); return null; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { cb(e.isIntersecting, e); }); }, opts || { threshold: 0.2 });
    io.observe(el);
    return io;
  }

  function openCart() {
    ['cart:refresh', 'cart:updated', 'hr:added'].forEach(function (ev) { document.dispatchEvent(new CustomEvent(ev, { bubbles: true })); });
    var d = document.querySelector('cart-drawer, #cart-drawer, .cart-drawer, [data-cart-drawer]');
    if (d && typeof d.refreshCartDrawer === 'function') {
      try { Promise.resolve(d.refreshCartDrawer()).then(function () { if (typeof d.open === 'function') d.open(); }).catch(function () { if (typeof d.open === 'function') d.open(); }); return; } catch (e) {}
    }
    if (d && typeof d.open === 'function') { try { d.open(); return; } catch (e) {} }
    var tg = document.querySelector('[data-cart-toggle], [data-cart-drawer-toggle], [aria-controls="cart-drawer"], #cart-icon-bubble, .header__icon--cart');
    if (tg) { tg.click(); return; }
    location.href = '/cart';
  }

  function init(root) {
    if (root.__hr) return; root.__hr = true;
    root.classList.add('js');

    /* reveal */
    var rv = root.querySelectorAll('.hr-rv');
    if (reduce || !('IntersectionObserver' in window)) { rv.forEach(function (n) { n.classList.add('in'); }); }
    else {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      rv.forEach(function (n) { io.observe(n); });
    }

    /* announcement rotation (mobile) */
    var rot = root.querySelectorAll('.hr-annc__rot span');
    if (rot.length > 1 && !reduce) {
      var ri = 0;
      setInterval(function () { rot[ri].classList.remove('on'); ri = (ri + 1) % rot.length; rot[ri].classList.add('on'); }, 3800);
    }

    /* hero light-cycle chip */
    var cyc = root.querySelector('[data-hr-cycle]');
    if (cyc && !reduce) {
      var ci = 2, nm = cyc.querySelector('.hr-cycle__nm'), nn = cyc.querySelector('.hr-cycle__nm-name');
      cyc.style.setProperty('--c', WL[ci].c);
      setInterval(function () { ci = (ci + 1) % WL.length; nm.textContent = WL[ci].nm; nn.textContent = WL[ci].name; cyc.style.setProperty('--c', WL[ci].c); }, 2600);
    }

    /* the light: frames + wavelength buttons */
    var light = root.querySelector('[data-hr-light]');
    if (light) {
      var frames = light.querySelectorAll('.hr-light__f');
      var btns = light.querySelectorAll('[data-wl]');
      var label = light.querySelector('[data-hr-light-label]');
      var cur = 2, timer = null, visible = false, userTook = false;
      function show(i) {
        cur = i; var w = WL[i];
        light.style.setProperty('--glow', w.c);
        frames.forEach(function (f) { f.classList.toggle('on', f.getAttribute('data-f') === w.k); });
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-wl') === w.k ? 'true' : 'false'); });
        if (label) label.textContent = w.nm + ' · ' + w.name;
      }
      function tick() { show((cur + 1) % WL.length); }
      function play() { if (reduce || userTook || timer || !visible) return; timer = setInterval(tick, 2800); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var k = b.getAttribute('data-wl');
          for (var i = 0; i < WL.length; i++) if (WL[i].k === k) { userTook = true; stop(); show(i); break; }
        });
      });
      light.addEventListener('pointerenter', stop);
      light.addEventListener('pointerleave', play);
      inView(light, function (on) { visible = on; if (on) play(); else stop(); }, { threshold: 0.35 });
    }

    /* reel arrows */
    var reel = root.querySelector('[data-hr-reel]');
    if (reel) {
      var track = reel.querySelector('[data-reel-track]');
      var prev = reel.querySelector('[data-reel-prev]'), next = reel.querySelector('[data-reel-next]');
      function step() { var c = track.querySelector('.hr-shot'); return c ? c.getBoundingClientRect().width + 20 : track.clientWidth * 0.8; }
      function sync() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }

    /* creator videos: load and play only while on screen; one with sound at a time */
    var ugc = root.querySelector('[data-hr-ugc]');
    if (ugc) {
      var vids = Array.prototype.slice.call(ugc.querySelectorAll('video[data-src]'));
      var load = function (v) { if (!v.src) { v.src = v.getAttribute('data-src'); } };
      if ('IntersectionObserver' in window) {
        var vio = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            var v = e.target;
            if (e.isIntersecting && e.intersectionRatio > 0.45) { load(v); if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
            else { v.pause(); }
          });
        }, { threshold: [0, 0.45, 0.8] });
        vids.forEach(function (v) { vio.observe(v); });
      } else { vids.forEach(load); }
      ugc.addEventListener('click', function (ev) {
        var b = ev.target.closest && ev.target.closest('[data-hr-snd]');
        var media = ev.target.closest && ev.target.closest('.hr-clip__media');
        if (!media) return;
        var v = media.querySelector('video'); if (!v) return;
        load(v);
        var turnOn = v.muted;
        vids.forEach(function (o) { o.muted = true; var ob = o.parentNode.querySelector('[data-hr-snd]'); if (ob) ob.setAttribute('aria-pressed', 'false'); });
        if (turnOn) { v.muted = false; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        var btn = b || media.querySelector('[data-hr-snd]'); if (btn) btn.setAttribute('aria-pressed', turnOn ? 'true' : 'false');
      });
    }

    /* quick add */
    var err = root.querySelector('[data-hr-err]');
    root.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('button[data-hr-add]');
      if (!b || !root.contains(b)) return;
      ev.preventDefault();
      var id = parseInt(b.getAttribute('data-hr-add'), 10); if (!id) return;
      var t = b.querySelector('.hr-add__t');
      b.setAttribute('aria-busy', 'true'); if (err) err.hidden = true;
      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart.'); return j; }); })
        .then(function () {
          b.removeAttribute('aria-busy'); b.classList.add('is-added'); if (t) t.textContent = 'Added';
          setTimeout(function () { b.classList.remove('is-added'); if (t) t.textContent = 'Add'; }, 2400);
          openCart();
        })
        .catch(function (e) { b.removeAttribute('aria-busy'); if (err) { err.textContent = e.message; err.hidden = false; } });
    });
  }

  function boot() { document.querySelectorAll('[data-hr]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
